import { SubmissionFunnelTypeEnum } from './types';

export const submissionQuestions = {
  submissionFunnelType: {
    labelKey: 'applicationForm.SUBMISSION.submissionFunnelType.label',
    options: [
      {
        labelKey: 'applicationForm.SUBMISSION.submissionFunnelType.option.direct.label',
        value: SubmissionFunnelTypeEnum.DIRECT,
      },
      {
        labelKey: 'applicationForm.SUBMISSION.submissionFunnelType.option.mortgageClub.label',
        value: SubmissionFunnelTypeEnum.MORTGAGE_CLUB,
      },
      {
        labelKey: 'applicationForm.SUBMISSION.submissionFunnelType.option.network.label',
        value: SubmissionFunnelTypeEnum.NETWORK,
      },
    ],
  },
};
